import React from 'react';
import PropTypes from 'prop-types';
import TableUtils from '../../../utils/TableUtils';
import {
    Button
} from 'react-bootstrap';
import {
    BootstrapTable,
    TableHeaderColumn
} from 'react-bootstrap-table';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import lstrings from '../../../utils/LStrings';

class TableAsociados extends React.Component {

	constructor(props) {
		super(props);
		this.state = {
			data: this.processData(props.data)
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			data: this.processData(nextProps.data)
		});
	}

	processData = (data) => {
		return data;
	}

	gridOptions = () => {
		return TableUtils.defaultConfig({
			pagination: true
		});
	}

	render() {
		return (
			<BootstrapTable data={this.state.data} options={this.gridOptions()} pagination>
					<TableHeaderColumn dataField="cuil" width='15%' isKey>
						{lstrings.docCuitCuil}
					</TableHeaderColumn>

					<TableHeaderColumn
						dataField="apellidoNombre"
						width='25%'
						dataSort>
						{lstrings.apellidosNombreRazon}
					</TableHeaderColumn>

					<TableHeaderColumn
						dataField="fechaDeAtraso"
						width='12%'
						dataFormat={TableUtils.dateFormat}
						dataSort>
						{lstrings.vigencia}
					</TableHeaderColumn>

					<TableHeaderColumn
						dataField="solgar"
						width='12%'
						dataSort>
						{lstrings.resp}
					</TableHeaderColumn>

					<TableHeaderColumn
						dataField="codDeEstado"
						width='12%'
						dataSort>
						{lstrings.estado}
					</TableHeaderColumn>

					<TableHeaderColumn
						dataField="referencia"
						width='12%'
						dataSort>
						{lstrings.referencia}
					</TableHeaderColumn>

				{/* La columna totales se incluye siempre */}
				<TableHeaderColumn
					dataField="deudaTotal"
					width='12%'
					dataFormat={TableUtils.ARSFormat}
					dataSort>
					{lstrings.monto}
				</TableHeaderColumn>
		
			</BootstrapTable>
		);
	}
}

TableAsociados.propTypes = {
    data: PropTypes.array,
}

export default TableAsociados;


// WEBPACK FOOTER //
// ./src/scenes/asociados/components/TableAsociados.js